import Check from 'components/Form/Check';
import React from 'react';
import { CheckContent, StyledLink, TermCheckContainer, Text } from './styled';

export default function TermCheck({ text, white, title, subtext, value, onChange, link }) {
  return (
    <TermCheckContainer white={white}>
      <Check onChange={onChange} checked={value} />
      <CheckContent>
        <Text>
          {title}
          {' '}
          <StyledLink onClick={link}>
            {text}
          </StyledLink>
        </Text>
        { subtext ? <Text small italic>{ subtext }</Text> : null }
      </CheckContent>
    </TermCheckContainer>
  );
}

